module.exports = __webpack_public_path__ + "static/media/parsnip.917b3fe5.jpg";